import { SearchInput } from '@/components/ui/search-input';
import { Switch } from '@/components/ui/switch';

interface Props {
  busca: string;
  onBuscaChange: (valor: string) => void;
  soProblemas: boolean;
  onSoProblemasChange: (valor: boolean) => void;
  /** Total de alvos atualmente visiveis apos filtro — exibido ao lado do toggle. */
  totalExibido: number;
  /** Total sem filtro — base da comparacao `exibido / total`. */
  totalBase: number;
}

export function MonitoramentoFilterBar({
  busca,
  onBuscaChange,
  soProblemas,
  onSoProblemasChange,
  totalExibido,
  totalBase,
}: Props) {
  return (
    <div className="flex flex-wrap items-center gap-3">
      <div className="flex-1 min-w-[200px] max-w-xs">
        <SearchInput value={busca} onChange={onBuscaChange} placeholder="Buscar alvo…" />
      </div>
      <label className="flex items-center gap-2 text-sm">
        <Switch
          checked={soProblemas}
          onCheckedChange={onSoProblemasChange}
          aria-label="Mostrar apenas alvos com problema"
        />
        <span>Só problemas</span>
      </label>
      {(busca || soProblemas) && (
        <span className="text-xs text-muted-foreground">
          {totalExibido} de {totalBase} alvos
        </span>
      )}
    </div>
  );
}
